import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const COLORS = ['#378add', '#16A34A', '#EA580C', '#DB2777', '#7C3AED', '#0891B2'];

const BarChartCard = ({ title, data, dataKey = "count", nameKey = "_id" }) => {
  return (
    <div className="card" style={{ 
      background: 'var(--color-background-primary)', 
      padding: '24px', 
      borderRadius: 'var(--border-radius-xl)',
      border: '1px solid var(--color-border-tertiary)',
      boxShadow: 'var(--shadow-sm)'
    }}>
      <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>{title}</h3>
      
      {data && data.length > 0 ? (
        <div style={{ height: '280px', width: '100%' }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              layout="vertical"
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="var(--color-border-tertiary)" />
              <XAxis type="number" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: 'var(--color-text-secondary)' }} />
              <YAxis 
                type="category" 
                dataKey={nameKey} 
                axisLine={false} 
                tickLine={false} 
                tick={{ fontSize: 13, fill: 'var(--color-text-primary)' }} 
                width={100}
              />
              <Tooltip 
                cursor={{ fill: 'var(--color-background-tertiary)' }}
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: 'var(--shadow-md)', fontSize: '13px' }}
              />
              <Bar dataKey={dataKey} radius={[0, 4, 4, 0]} barSize={24}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div style={{ height: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-text-tertiary)', fontSize: '13px' }}>
          No data available
        </div>
      )}
    </div>
  );
};

export default BarChartCard;
